var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-full header-wrapper flex items-center header-palce",staticStyle:{"height":"0.3rem"}},[_c('img',{staticClass:"logo cursor-pointer",attrs:{"src":require("@/assets/images/logo.png")},on:{"click":_vm.jumphome}}),_c('Search'),_c('Navbar'),_c('User')],1),_c('div',{staticClass:"header-palce"})])
}
var staticRenderFns = []

export { render, staticRenderFns }